import React from 'react';

export const Context = React.createContext(null);

export default Context;
